import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { inlineMessageVariants } from './variants';
const InlineMessage = React.forwardRef((_a, ref) => {
    var { className, variant, icon, children, actions, as: Component = 'div' } = _a, attributes = __rest(_a, ["className", "variant", "icon", "children", "actions", "as"]);
    const classes = clsx(inlineMessageVariants({ variant }), className);
    return (React.createElement(Component, Object.assign({}, attributes, { className: classes, role: 'alert', ref: ref }),
        icon,
        React.createElement("div", { className: 'inline-message__content' }, children),
        actions && React.createElement("div", { className: 'inline-message__actions' }, actions)));
});
InlineMessage.displayName = 'InlineMessage';
export { InlineMessage };
//# sourceMappingURL=InlineMessage.js.map